import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase environment variables not set. Auth features will be unavailable.");
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        detectSessionInUrl: true,
        autoRefreshToken: true,
        persistSession: true,
      },
    })
  : null;

// Headers for /api/chat. Adds the signed-in user's token (if any) so the server
// can check their plan. Signed-out visitors just get Content-Type.
export async function chatHeaders() {
  const headers = { "Content-Type": "application/json" };
  try {
    const { data: { session } } = supabase ? await supabase.auth.getSession() : { data: {} };
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  } catch {
    // Fall back to an anonymous request
  }
  return headers;
}
